/**
 * TBD
 */ export var APP_PROMOTION_BANNER_LINKS = 'APP_PROMOTION_BANNER_LINKS';
